import {useEffect} from "react";
import {useFeatureFlag} from "./useFeatureFlag";
import {useLocation} from "react-router-dom";

export const usePathRelatedStyles = () => {
  const location = useLocation();
  const pathsWithBackGround = ['/trial', '/sign-up', '/sign-in']
  const backGroundFeatureFlag = useFeatureFlag('backGroundImage');

  useEffect(() => {
    if( pathsWithBackGround.includes(location.pathname) && backGroundFeatureFlag) {
      document.body.classList.add('back-ground-image');
    } else {
      document.body.classList.remove('back-ground-image');
    }
  }, [location.pathname]);
}